var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button",class:{ active: _vm.val },on:{"click":_vm.toggle}},[_c('div',{staticClass:"switch"},[(_vm.computedIcon)?_c('i',{class:_vm.computedIcon}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }